module.exports = __webpack_public_path__ + "11c97ef396afcff2dba924388ab1af25.svg";